import { ICreateEntregaObrasClienteArquivoUseCase } from "../../../presentation/useCases/create/create_entrega_obras_cliente_arquivo_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateEntregaObrasClienteArquivoUseCase
 */

export class CreateEntregaObrasClienteArquivoUseCase implements ICreateEntregaObrasClienteArquivoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
  }
  async execute(
    idEntregaObra: number,
    descricao?: string,
    arquivo?: File
  ): Promise<number> {
    const computedArquivoNome = arquivo ? arquivo.name : null;
    const computedArquivo = arquivo ? arquivo : undefined;

    return await this.repository.createEntregaObrasClienteArquivos(
      idEntregaObra,
      computedArquivoNome ? computedArquivoNome : undefined,
      descricao,
      computedArquivo,
    );
  }
}
